import { API_BASE_URL } from '../config';

const VID_KEY = 'peony_vid';

export function getVisitorId() {
  let id = null;
  try {
    id = localStorage.getItem(VID_KEY);
  } catch (_) { /* localStorage may throw in private mode */ }
  if (!id) {
    id = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : 'v-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    try { localStorage.setItem(VID_KEY, id); } catch (_) { /* ignore */ }
  }
  return id;
}

export function track(eventType, path, referrer = null) {
  if (typeof path !== 'string') return;
  if (path.startsWith('/admin') || path === '/login') return;

  const body = JSON.stringify({
    eventType,
    path,
    referrer: referrer || null,
    visitorId: getVisitorId(),
  });
  const url = `${API_BASE_URL}/api/track`;

  try {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
      return;
    }
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => { /* swallow — analytics must never break the page */ });
  } catch (_) {
    /* swallow */
  }
}
